module.exports = "/shiftTasks/components/taskInstances/taskInstancesList/taskInstanceListItem-709686.html";